module.exports = __webpack_public_path__ + "static/media/menuWarning.93b092e2.svg";